import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Hidden from  '@material-ui/core/Hidden';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar'
import Step from '@material-ui/core/Step';
import Link from '@material-ui/core/Link';
import StepLabel from '@material-ui/core/StepLabel';
import {Button,CardActions, TextareaAutosize }  from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import {schema} from './schemas';
import InputField from '../../components/FormFields/InputField';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { alertActions, StatisticsActions } from '../../_actions';
import { connect, useDispatch, useSelector} from 'react-redux';
const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width:1000,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
}));

export default function StepComponent() {
  
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  //const registering = useSelector(state => state.statistics.registered);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  var files=[]; 

  const formData = new FormData();
  const SubirArchivos=(e,text)=>
  {       
     files.push(e[0]);   
    
    //console.log(documentos);
    //FormData file1;    
    //file1.append(text, e);    
    //return file1;
  }
 
  return (
    
    <React.Fragment>
      <CssBaseline />
      <AppBar position="absolute" color="default" className={classes.appBar}>       
      </AppBar>
      <main className={classes.layout}>
      <Paper className={classes.paper}>  
      <Typography component="h1" variant="h4" align="center">
       Solicitud de Información Estadística    
      </Typography>       
      <div>       
          <div>
            <Typography className={classes.instructions}>
            <Formik
            initialValues={{
               FirstName: '',
               LastName: '',
               position:'',
               date:'',
               information:'',
               phone:''
              }}
      validationSchema={schema}
      onSubmit={(values,actions) => {
        //console.log("Esto es data",documentos);
        //submit(3);
        //console.log(files);     
         
       //setData({ ...files,...data})
       dispatch(StatisticsActions.insertarTramiteStatistics({ ...files, ...values})); 
       actions.resetForm({values :''});
       /*if(registering){
        navigate('/app/misTramites', { replace: true });
       } */

      }}
      
    >
      <Form>

      <br/>
      <br/>
      <Grid container spacing={3}>
      
      <Grid item xs={12} sm={6}>
        <InputField
          required
          id='FirstName'
          name='FirstName'
          label='Nombre'
          fullWidth     
          variant="outlined"       
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputField  required id='LastName' name='LastName' label='Apellidos' fullWidth  variant="outlined" />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputField  required id='position' name='position' label='Cargo' fullWidth  variant="outlined"/>
      </Grid>
      <Grid item xs={12} sm={3}>
        <InputField type="date"  required id='date' name='date' label='Fecha Límite' fullWidth  variant="outlined"  InputLabelProps={{ shrink: true }} />
      </Grid>         
            
      <Grid item xs={12} sm={3}>
        <InputField required  id='phone' name='phone' label='Teléfono de Verificación' fullWidth   variant="outlined"/>
      </Grid>
      <Grid item xs={12} sm={6}>    
      <InputField
      fullWidth
      id="information"
      name="information"
      label="Información Solicitada"
      multiline
      rows={5}      
      variant="outlined"
      />
      </Grid>
      
      <Grid item xs={12} sm={6}>   
      <br/> 
      <br/> 
       <label> Carta Acuñada por el directivo de la institución </label>
                   
           
           <InputField 
            required
           name='resumen_tesis'
           onChange={(e)=> SubirArchivos(e.target.files,'resumen_tesis')
           }           
           id='resumen_tesis'
           type="file"  
           variant="outlined"
           inputProps={{accept:".doc,.docx,.pdf"}}  
                
           />
          
        </Grid>   
        
      
         </Grid> 
         <span>       
        <Button
                    //disabled={isSubmitting}
                    type="submit"
                    variant="contained"                    
                    color="primary"                   
                    //onClick={_handleSubmit}
                    className={classes.button}
                  >     Enviar  
        </Button>
        </span>   
       </Form>
      </Formik>
            </Typography>
          </div>
              
     </div>
      </Paper>  
      </main>          
    </React.Fragment>    
  );
}
